<template>
	<div class="container">
		<dv-border-box-13 :key="key1">
			 <div class="warn_work" style="font-size: 12px;">		
				<div class="title">
					<img src='../../assets/img/tit2.png' style='height:.2rem; padding-right: 5px;' />
					告警信息
				</div>
				<el-scrollbar v-show="awarningList.length>0" style="height: 1.2rem;border-bottom: 1px solid #dd0105;color: #dd0105;">
					<ul style="padding: inherit;">
						<li v-for="(item, index) in awarningList" :key="index"  class="row" style="justify-content: space-around;line-height: 30px;">
							<div v-if="item.carName" :title="item.carName" 
								style="width: 1.2rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
								{{item.carName}} 
							</div>						
							<div v-if="item.updateTime"  style="width: .8rem;text-align: left; text-overflow: ellipsis;overflow: hidden">
										{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
							</div>
							<div v-if="item.info" :title="item.info" 
								style="width: 1.2rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
									{{item.info}}
							</div>	
							<!-- <div v-if="item.info" v-on:click="handleWarnDetail(item)" style="color: #409EFF;width: .5rem;text-align: left;">详情</div>	 -->
							<!-- <div v-if="item.id" v-on:click="handleWarn(item.id)" style="color: #34cb23;width: .5rem;text-align: left;">已读</div> -->	
							<el-button v-if="item.info" v-on:click="handleWarnDetail(item)" size="mini" type="primary" class="warnbtn">详情</el-button>		
							<el-button v-if="item.id" v-on:click="handleWarn(item.id)" size="mini" type="success" class="warnbtn" style="width:.7rem">已处理</el-button>		
						</li>
					</ul>
				</el-scrollbar>	
				<el-scrollbar v-if="bwarningList.length>0" style="height: 1rem;border-bottom: 1px solid #F19F19;color: #F19F19;">
					<ul style="padding: inherit;">
						<li v-for="(item, index) in bwarningList" :key="index"  class="row" style="justify-content: space-around;line-height: 30px;">
							<div v-if="item.carName" :title="item.carName" 
								style="width: 1rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
									{{item.carName}} 
							</div>						
							<div v-if="item.updateTime"  style="width: .8rem;text-align: left; text-overflow: ellipsis;overflow: hidden">
										{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
							</div>
							<div v-if="item.info"  :title="item.info" 
								style="width: 1.2rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
								{{item.info}}
							</div>
							<el-button v-if="item.info" v-on:click="handleWarnDetail(item)" size="mini" type="primary" class="warnbtn">详情</el-button>		
							<el-button v-if="item.id" v-on:click="handleWarn(item.id)" size="mini" type="success" class="warnbtn" style="width:.7rem">已处理</el-button>		
						</li>
					</ul>
				</el-scrollbar>	
				<el-scrollbar  v-if="cwarningList.length>0" style="height: 1rem;border-bottom: 1px solid #ebeb75;color: #ebeb75;">
					<ul style="padding: inherit;">
						<li v-for="(item, index) in cwarningList" :key="index"  class="row" style="justify-content: space-around;line-height: 30px;">
							<div v-if="item.carName" :title="item.carName" 
								style="width: 1rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
								{{item.carName}} 
							</div>						
							<div v-if="item.updateTime"  style="width: .8rem;text-align: left; text-overflow: ellipsis;overflow: hidden">
										{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
							</div>
							<div v-if="item.info" :title="item.info" 
								style="width: 1.2rem;text-align: left; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
									{{item.info}}
							</div>		
							<el-button v-if="item.info" v-on:click="handleWarnDetail(item)" size="mini" type="primary" class="warnbtn">详情</el-button>		
							<el-button v-if="item.id" v-on:click="handleWarn(item.id)" size="mini" type="success" class="warnbtn" style="width:.7rem">已处理</el-button>			
						</li>
					</ul>
				</el-scrollbar>	
			</div>			
		</dv-border-box-13>
		
		<dv-border-box-12 :key="key2">
			<div class="areaview">
				<div class="safety">
					<div class="safety-container">
					    <div class="days-circle">
					        <span class="days-number">{{entity.days}}</span>
					        <span class="days-unit">天</span>
					    </div>
					    <div class="safety-label">安全作业天数</div>
					</div>
					
					<div class="safety-container">
					    <div class="days-circle">
					       <span class="days-number">{{entity.duration}}</span>
					       <span class="days-unit">时</span>
					    </div>
					    <div class="safety-label">安全作业时长</div>
					</div>
					
					<div class="safety-container">
					    <div class="days-circle">
					        <span class="days-number">{{entity.num}}</span>
					        <span class="days-unit">次</span>
					    </div>
					    <div class="safety-label">安全作业次数</div>
					</div>
				</div>
				
				<div class="custom">
					<!-- 
					<div class="time-indicator">
					       // 多层菱形边框 
					        <div class="diamond"></div>
					        <div class="diamond"></div>
					        <div class="diamond"></div>
					        <div class="diamond"></div>
					        <div class="diamond"></div>
					        // 文字内容
					        <div class="content">
					            <div class="title">{{entity.carTotal}}</div>
					            <div class="label">机器人投放数量</div>
					        </div>
					</div>
					 -->
					<dv-decoration-9 class="number">
						<div class="content">
						    <div class="title">{{entity.carTotal}}</div>
						    <div class="label">机器人投放数量</div>
						</div>
					</dv-decoration-9 >	
					
					<dv-decoration-12 class="real">
						<div class="content">
						    <div class="title">{{entity.carLine}}</div>
						    <div class="label">实时在线数量</div>
						</div>
					</dv-decoration-12>
				</div>			
			</div>
		</dv-border-box-12>
		
		<dv-border-box-11 title="当  日  天  气" :key="key3">
			<div class="weather" style="height: 68px;">			
				<div class="row" style="justify-content: space-evenly;">
					<div class="col box" style="align-items: flex-end; width: 30%">
						<img :src="weather.icon" />
					</div>
					<div class="col" style="width:70%;">
						<div class="row" style=" align-items: center;">
							<font class="fontg">{{weather.text}}</font>
							<font class="fontg">&nbsp;&nbsp;|&nbsp;&nbsp;{{weather.windLevel}}&nbsp;&nbsp;|&nbsp;&nbsp;</font>
							<font class="fontg">{{weather.windDirection}}</font>				
						</div>	
						<div class="row box2">
							<img src="../../assets/img/toast2.png" style="height: 25px;width: 25px;" />
							<font>{{weather.toast}}</font>
						</div>
					</div>				
				</div>				
			</div>	
			
		</dv-border-box-11>
		
		<!-- 
		<div class="areaview">
			<img src="../../assets/img/timer.png" class="img">
			<div class="workexecue">
				<div>
					<div class="tit">总清扫时长 | 总执行次数</div>
					<div class="data"><font>{{entity.duration}}</font>小时 | <font>{{entity.num}}</font>次</div>
				</div>
				<div class="workrate">
					<div>
						<div class="data" style="color: #8b8888;">{{entity.workCompleteRate}} %</div>
						<div class="tit" style="color: #8b8888;">任务完成率 </div>
						<img src="../../assets/img/titbg.png" class="img">
					</div>
					<div>
						<div class="data" style="color: #8b8888;">{{entity.worksNum}} 个</div>
						<div class="tit" style="color: #8b8888;">任务总数 </div>
						<img src="../../assets/img/titbg2.png" class="img">
					</div>
				</div>	
			</div>
		</div>
		 -->
		<!-- 
		<dv-border-box-13>
			 <div class="warn_work">		
				<div class="title">
					<img src='../../assets/img/tit2.png' style='height:.2rem; padding-right: 5px;' />
					告警信息
				</div>				
				<div class="car_work" style="justify-content: space-evenly;color: #dd0105;">
					<scroll :data="warningList" :class-option="scrollOption" class="box">
						<div v-if="warningList.length > 0">
							<div class="boxnav" v-for="(item,index) in warningList" :key="index" >
								<div v-if="item.carName" class="boxitem" style="width:1.5rem;" >{{item.carName}} </div>
								<div v-if="item.workName" class="boxitem" style="width:1.5rem;" >
									{{item.workName.indexOf('-') > 0 ? item.workName.substring(0,item.workName.indexOf('-')) : item.workName}}
								</div>
								<div v-if="item.updateTime" class="boxitem" style="width:1rem;">
									{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
								</div>
								<div v-if="item.info" class="boxitem" style="width:3rem;">{{item.info}}</div>
							</div>
						</div>					
					</scroll>		
				</div>	
			 </div>
		 </dv-border-box-13>
		 -->
		<dv-border-box-13 :key="key4">
			<div class="workingview">		
				<div class="title">
					<img src='../../assets/img/tit2.png' style='height:.2rem; padding-right: 5px;' />
					执行中作业
				</div>	
				<div class="car_work" style="justify-content: space-evenly;color: #FFFFFF;">
					<scroll :data="workingList" :class-option="scrollOption" class="box">
						<div class="boxnav" v-for="(item,index) in workingList" :key="index" v-on:click="handleExecuteWork(0,item)">						
							<div class="boxitem" :title="item.carName" style="width:1.2rem;" >{{item.carName}} </div>
							<div class="boxitem" :title="item.missionName" style="width:1.5rem;" >
								{{item.missionName.indexOf('-') > 0 ? item.missionName.substring(0,item.missionName.indexOf('-')) : item.missionName}}
							</div>
							<div class="boxitem" :title="item.missionFunc" style="width:1rem;" >{{item.missionFunc}}</div>
							<div class="boxitem" style="width:.6rem;color: #409EFF;" >
								<div v-if = "item.missionStatus == 1">
									执行中
								</div>
								<div v-else-if = "item.missionStatus == 2">
									暂停中
								</div>
							</div>
						</div>
					</scroll>			
				</div>	
				<!-- 
				<div v-if="multiWorkingList.length > 0" class="dividing_line"></div>		
				<div class="car_work" style="justify-content: space-evenly;">
					<scroll :data="multiWorkingList" :class-option="scrollOption" class="box">
						<div class="boxnav" v-for="(item,index) in multiWorkingList" :key="index" v-on:click="handleExecuteWork(1,item)">					
							<div class="boxitem" style="width:1rem;" >{{item.carName}} </div>
							<div class="boxitem" style="width:1.5rem;" >
								{{item.workName}}
							</div>
							<div class="boxitem" style="width:1.5rem;" ></div>
							<div class="boxitem" style="width:1rem;" >
								<div v-if = "item.workStatus == 1">
									执行中
								</div>
								<div v-else-if = "item.workStatus == 2">
									暂停中
								</div>
							</div>
						</div>
					</scroll>			
				</div>	
				 -->	
			</div>
		</dv-border-box-13>
	</div>
</template>

<script>
	import scroll from 'vue-seamless-scroll'
	
	import {getIndexEntityCustomView,getIndexEntityWork,getIndexEntityWarning,getWeather,handleWarning} from '../../api/entity.js'
	export default{
		inject: ['executeWorkDetailSwitch','updateWeather','warnDetailSwitch'],
		props: {
			selectedEntity:{
				type:String
			},
		},
		watch: {
			selectedEntity:{
				handler(newData) {
					if(newData != null && newData != ""){
						this.entityid = newData
						this.initEntityInfo()
						this.initExecuteWorkByEntity()
						this.initCarDayWarning()
						this.handleWeather()
						
						this.initRealWarnAndWorkInterval()
						
						this.pieOutlineFunc()
					}
				},
				immediate: true, //最初绑定值的时候也执行函数
				deep: true //监听一个对象的改变
			},
		},
		components: {
		   scroll
		},
		mounted() {
			this.pieOutlineFunc()
		},
		destroyed() {
			this.clearWarnAndWorkInterval()
		},
		data(){
			return{	
				loginuser:localStorage.getItem('username'),
				entityid:'',
				entity:{},
				// camerainfos:[],
				// camerainfo:{},
				// url:""
				workingList:[],
				scrollOption: {
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 5, // 开始无缝滚动的数据量
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 2000 // 单步运动停止的时间(默认值1000ms)
				},
				multiWorkingList:[],
				warningList:[],
				awarningList:[],
				bwarningList:[],
				cwarningList:[],
				weather:{},
				weatherIcon:{
					sun:require('../../assets/img/weather/weather-sun.png'),
					cloud:require('../../assets/img/weather/weather-cloud.png'),
					cloudy:require('../../assets/img/weather/weather-cloudy.png'),
					hail:require('../../assets/img/weather/weather-hail.png'),
					dust:require('../../assets/img/weather/weather-dust.png'),
					haze:require('../../assets/img/weather/weather-haze.png'),
					rain:require('../../assets/img/weather/weather-rain.png'),
					rainsnow:require('../../assets/img/weather/weather-rainsnow.png'),
					ray:require('../../assets/img/weather/weather-ray.png'),
					snow:require('../../assets/img/weather/weather-snow.png'),
					fog:require('../../assets/img/weather/weather-fog.png'),
					icerain:require('../../assets/img/weather/weather-icerain.png'),
					tornado:require('../../assets/img/weather/weather-tornado.png')
				},
				
				warnWorkInterval:null,
				key1:0,
				key2:0,
				key3:0,
				key4:0
			}
		},
		methods:{
			initEntityInfo(){
				let that = this
				getIndexEntityCustomView(that.entityid).then(res =>{
					if(res.result == 0){
						that.entity = res.entityInfo
						
						var area = that.entity.workArea
						if(area >= 10000){
							var area2 = (area/10000).toFixed(2)
							that.entity.workArea =  area2+"万"
						}else{
							that.entity.workArea = area
						}
						
						var mile = that.entity.milege
						if(mile >= 10000){
							var mile2 = (mile/10000).toFixed(2)
							that.entity.milege =  mile2+"万"
						}else{
							that.entity.milege = mile
						}
						
						// var wkrate = that.entity.workCompleteRate*100	
						// that.entity.workCompleteRate = wkrate.toFixed(2)
						
						var duration1 = that.entity.duration.toString()
						let i = duration1.indexOf('.')
						if( i > 0){
							duration1 = duration1.substring(0,i)
						}
						if(duration1 >= 10000){
							var duration2 = (duration1/10000).toFixed(1)
							that.entity.duration =  duration2+"万"
						}else{
							that.entity.duration = duration1
						}
						
						//虚拟数据
						if(this.loginuser === 'admin'){
							that.entity.duration = 16327
							that.entity.num = 50494
						}	
						
					}else{
						this.$message({
							message: '未获取到运营单位运营概况信息',
							type: 'error'
						});	
						this.entity = {}
					}
				})
			},
			initExecuteWorkByEntity(){
				let  that = this
				getIndexEntityWork(that.entityid).then(res =>{
					if(res.result == 0){
						if(res.carWorkList != null && res.carWorkList.length > 0){
							that.workingList = res.carWorkList
						}else{
							this.$message({
								message: '未获取到单位执行中机器人作业信息',
								type: 'info'
							});
							this.workingList = []
							var warnnone = {
								missionName:'无执行中作业'
							}
							this.workingList.push(warnnone)
						}
							
						// if(res.carMultiWorkList != null && res.carMultiWorkList.length > 0){
						// 	that.multiWorkingList = res.carMultiWorkList
						// }else{
						// 	this.$message({
						// 		message: '未获取到单位执行中机器人组合作业信息',
						// 		type: 'info'
						// 	});
						// 	this.multiWorkingList = []
						// 	var warnnone = {
						// 		workName:'无执行中组合作业'
						// 	}
						// 	this.multiWorkingList.push(warnnone)
						// }
						
					}else{
						this.$message({
							message: '未获取到单位执行中机器人作业信息',
							type: 'error'
						});
						this.workingList = []
						this.multiWorkingList = []
					}
				})
			},
			initCarDayWarning(){
				let that = this
				that.warningList = []
				that.awarningList = []
				that.bwarningList = []
				that.cwarningList = []
				getIndexEntityWarning(this.entityid).then(res =>{
					if(res.result == 0){
						if(res.warningList != null && res.warningList.length > 0){			
							that.warningList = res.warningList
							that.handleWarnLevel(that.warningList)
						}else{
							var warnnone = {
								carName:'无告警'
							}
							that.awarningList.push(warnnone)
						}					
					}else{
						this.$message({
							message: '未获取到单位当日告警信息',
							type: 'error'
						});
						this.warningList = []
						var warnnone = {
							carName:'无告警'
						}
						that.awarningList.push(warnnone)
					}
					this.pieOutlineFunc()
				})
			},
			handleExecuteWork(wktype,working){
				if(working.carName!=null){
					this.executeWorkDetailSwitch(wktype,working)
				}			
			},
			handleWarnLevel(warningList){
				if(this.warningList.length <= 0){
					return
				}
				this.warningList.forEach((item,index)=>{
					var warn = item.info
					if(warn.indexOf('停车告警')>=0 || warn.indexOf('电池电压低') >=0){
						this.awarningList.push(item)
					}else if(warn.indexOf('垃圾箱容量不足')>=0 || warn.indexOf('清水箱不足') >=0 || warn.indexOf('作业即将完成') >=0 || warn.indexOf('充电完成') >=0){
						this.bwarningList.push(item)
					}else if(warn.indexOf('需要更换')>=0 ){
						this.cwarningList.push(item)
					}
				})
				if(this.awarningList.length == 0 && this.bwarningList.length == 0  && this.cwarningList.length == 0){
					var warnnone = {
						carName:'无告警'
					}
					this.awarningList.push(warnnone)
				}
			},
			handleWarnDetail(warn){	
				var entityid = warn.entityId,carid = warn.carId,warntype = warn.statusOther,
				warnworking = null,warnpic = false //,worktype = warn.workType,workid = warn.workId,workname = warn.workName
				if(this.workingList.length > 0){
					this.workingList.forEach((item,index)=>{
						if(item.carId == carid){
							warnworking = {
								wktype:0,
								workingdetail:item
							}
							return
						}
					})
				}
				if(warntype == 6){
					warnpic = true
				}
				this.warnDetailSwitch(entityid,carid,warnworking,warnpic)				
			},
			handleWarn(id){
				handleWarning(id).then(res=>{
					if(res.result == "1"){
						this.$message({
							message: '处理成功',
							type: 'success'
						});
						this.initCarDayWarning()
					}else{
						this.$message({
							message: '处理失败',
							type: 'warning'
						});
					}
				})				
			},
			updateIndexWeather(icon) {
			   // console.log(icon)
			   this.updateWeather(icon)
			},
			initRealWarnAndWorkInterval(){
				this.warnWorkInterval = setInterval(()=>{				
					this.initExecuteWorkByEntity()
					this.initCarDayWarning()
				},1*60*1000)
			},
			clearWarnAndWorkInterval(){
				clearInterval(this.warnWorkInterval); //清除计时器
				this.warnWorkInterval = null; //设置为null
			},
			handleWeather(){
				let _this = this
				getWeather(this.entityid).then(res =>{
					// console.log(res)				
					if(res.status != 0 ){
						this.$message({
							message: '天气获取失败',
							type: 'error'
						});
						return
					}
					
					var weatherInfo = res.result.now
					let text = weatherInfo.text,windDirection = weatherInfo.wind_dir,windLevel = weatherInfo.wind_class
					let toast = '适宜清扫任务'			
					
					let icon = _this.weatherIcon.sun
					if(text == '多云'){
						icon = _this.weatherIcon.cloud
					}else if(text == '阴'){
						icon = _this.weatherIcon.cloudy
					}else if(text == '阵雨' || text == '雷阵雨' ){
						icon = _this.weatherIcon.ray
						toast = '不适宜清扫任务'			
					}else if(text == '雷阵雨伴有冰雹'){
						icon = _this.weatherIcon.hail
						toast = '不适宜清扫任务'			
					}else if(text == '雨夹雪'){
						icon = _this.weatherIcon.rainsnow
						toast = '不适宜清扫任务'			
					}else if(text == '雨' || text == '小雨' || text == '中雨' || text == '大雨' || text == '暴雨' || text == '大暴雨'|| text == '特大暴雨'
						|| text == '小到中雨' || text == '中到大雨' || text == '大到暴雨' || text == '暴雨到大暴雨'|| text == '大暴雨到特大暴雨'){
						icon = _this.weatherIcon.rain
						toast = '不适宜清扫任务'			
					}else if(text == '雪' || text == '阵雪' || text == '小雪' || text == '中雪'|| text == '大雪'|| text == '暴雪'
						|| text == '小到中雪' || text == '中到大雪'|| text == '大到暴雪' || text == '弱高吹雪'){
						icon = _this.weatherIcon.snow
						toast = '不适宜清扫任务'			
					}else if(text == '雾' || text == '浓雾' || text == '轻雾' || text == '强浓雾' || text == '大雾' || text == '特强浓雾'){
						icon = _this.weatherIcon.fog
					}else if(text == '冻雨'){
						icon = _this.weatherIcon.icerain
						toast = '不适宜清扫任务'			
					}else if(text == '龙卷风'){
						icon = _this.weatherIcon.tornado
						toast = '不适宜清扫任务'			
					}else if(text == '沙尘暴'){
						icon = _this.weatherIcon.dust
						toast = '不适宜清扫任务'			
					}else if(text == '霾' || text == '中度霾' || text == '重度霾'|| text == '严重霾'|| text == '重度霾'){
						icon = _this.weatherIcon.haze
					}
					
					let weathers = {
						text : text,
						windDirection  : windDirection,
						windLevel  : windLevel,
						toast  : toast,
						icon:icon
					}
					_this.weather = weathers
					_this.updateIndexWeather(icon)
				})
			},
			 pieOutlineFunc() {
			      var _this = this
			      window.addEventListener('pageshow', function (e) {
			        _this.$nextTick(() => {
			          _this.key1++;
					  _this.key2++;
					  _this.key3++;
					  _this.key4++;
			        })
			      })
			}

		}
	}
</script>

<style>
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>

<style  lang="scss" scoped>
	.container{
		z-index: 1000;
		position: fixed;
		top:10%;
		left:.2rem;
		width: 20%;
		display: flex;
		flex-direction: column;
		justify-content:left;
		color: #fff;
		font-size: 20px;
		text-align: center;
		background:rgba(22,26,99,.8);
		padding-bottom: 5px;
		padding-top: 5px;
	}
	
		.safety-container {
	        text-align: center;
	        width: 100%;
	        max-width: 120px;		
	    }
	        
	    .days-circle {
	        width: 80px;
	        height: 80px;
	        background: linear-gradient(145deg, rgb(3,166,224),rgb(22,26,99));
	        border-radius: 50%;
	        margin: 0 auto 10px;
	        display: flex;
	        flex-direction: column;
	        justify-content: center;
	        align-items: center;
	        position: relative;
	        // box-shadow: 
	        //     8px 8px 16px rgba(0, 0, 0, 0.1),
	        //     -8px -8px 16px rgba(22,26,99, 0.7),
	        //     inset 0 0 20px rgba(22,26,99, 0.5);
	        border: 1px solid rgba(3,166,224, 0.6);
	    }
	        
	    /* 添加光晕效果 */
	    .days-circle::before {
	        content: '';
	        position: absolute;
	        top: -5px;
	        left: -5px;
	        right: -5px;
	        bottom: -5px;
	        border-radius: 50%;
	        background: linear-gradient(145deg, rgba(22,26,99,0.8), rgba(22,26,99,0.8));
	        z-index: -1;
	        filter: blur(10px);
	        opacity: 0.7;
	    }
	        
	    .days-number {
	        font-size: 20px;
	        font-weight: 900;
	        color: #fff;
	        line-height: 1;
	        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
	        margin-top: -5px;
	        // letter-spacing: -2px;
	    }
	        
	    .days-unit {
	        font-size: 15px;
	        color: #fff;
	        position: absolute;
	        // right: 45px;
	        bottom: 5px;
	        font-weight: 600;
	    }
	        
	    .safety-label {
	        font-size: 12px;
	        color: #fff;
	        // margin-top: 10px;
	        font-weight: 500;
	        letter-spacing: -2px;
	    }
	        
	    /* 添加底部装饰线 */
	    .safety-label::after {
	        content: '';
	        display: block;
	        width: 60px;
	        height: 2px;
	        background: linear-gradient(to right, transparent, rgb(3,166,224), transparent);
	        margin: 8px auto 0;
	    }
	        
	    /* 响应式调整 */
	    @media (max-width: 480px) {
	        .days-circle {
	            width: 200px;
	            height: 200px;
			}
	            
	        .days-number {
	            font-size: 64px;
	        }
	            
	        .days-unit {
	            font-size: 18px;
	            right: 38px;
	            bottom: 48px;
	        }
	            
	        .safety-label {
	            font-size: 15px;
	        }
	    }
	        
	    /* 添加动画效果 */
	    .days-circle {
	        animation: float 3s ease-in-out infinite;
	    }
	        
	    @keyframes float {
	            0% { transform: translateY(0px); }
	            50% { transform: translateY(-5px); }
	            100% { transform: translateY(0px); }
	    }
	        
	    /* 添加点击效果 */
	    .days-circle:active {
	        transform: scale(0.98);
	        box-shadow: 
	                4px 4px 8px rgba(0, 0, 0, 0.1),
	                -4px -4px 8px rgba(3,166,224, 0.7),
	                inset 0 0 10px rgba(3,166,224, 0.5);
	    }
		
		
		.time-indicator {
		    position: relative;
		    width: 100px;
		    height: 100px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
			margin-left: .5rem;
		}
		        
		/* 多层菱形边框效果 */
		.diamond {
		    position: absolute;
		    width: 100%;
		    height: 100%;
		    transform: rotate(45deg);
		    border: 2px solid rgba(3,166,224, 0.1);
		    // animation: pulse 3s infinite alternate;
			animation: pulse 5s ease-in-out infinite alternate;
		}
		        
		.diamond:nth-child(1) {
		    width: 100%;
		    height: 100%;
		    border-color: rgba(3,166,224, 0.2);
		    box-shadow: 0 0 10px rgba(3,166,224, 0.2);
		}
		        
		.diamond:nth-child(2) {
		    width: 80%;
		    height: 80%;
		    border-color: rgba(3,166,224, 0.4);
		    box-shadow: 0 0 15px rgba(3,166,224, 0.3);
		}
		        
		.diamond:nth-child(3) {
		    width: 60%;
		    height: 60%;
		    border-color: rgba(3,166,224, 0.6);
		    box-shadow: 0 0 20px rgba(3,166,224, 0.4);
		}
		        
		.diamond:nth-child(4) {
		    width: 40%;
		    height: 40%;
		    border-color: rgba(3,166,224, 0.8);
		    box-shadow: 0 0 25px rgba(3,166,224, 0.5);
		}
		        
		.diamond:nth-child(5) {
		    width: 20%;
		    height: 20%;
		    border-color: rgba(3,166,224, 1);
		    box-shadow: 0 0 30px rgba(3,166,224, 0.7);
		}
		        
		/* 文字内容 */
		.content {
		    position: relative;
		    z-index: 10;
		    text-align: center;
		    color: white;
		    // transform: rotate(-45deg);
		}
		        
		.title {
		    font-size: 20px;
		    font-weight: 800;
		    letter-spacing: 1px;
		    margin-bottom: 5px;
		}
		        
		.label {
		    font-size: 12px;
		    font-weight: 400;
		    letter-spacing: 2px;
		}
		        
		/* 发光动画 */
		@keyframes pulse {
		    0% {
		        opacity: 0.5;
		    }
		    100% {
		        opacity: 1;
		    }
		}
		        
		/* 响应式调整 */
		@media (max-width: 480px) {
		    .time-indicator {
		        width: 250px;
		        height: 250px;
		    }
		            
		    .title {
		        font-size: 2rem;
		    }
		            
		    .label {
		        font-size: 1rem;
		    }
		}
		
	
	.areaview{
		display: flex;
		flex-direction: column;
		justify-content:left;
		padding: 0.2rem 0.1rem 0.2rem 0.1rem;
		.safety{
			display: flex;
			flex-direction: row;
			justify-content:left;
		}
		
		.custom{
			display: flex;
			flex-direction: row;
			justify-content:space-evenly;
			margin-top: .15rem;
		}	
		
		.number{
			width:100px;
			height:100px;
		}
		
		.real{
			width:100px;
			height:100px;
		}
		
	}
	.col{
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.row{
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	.row2{
		justify-content: space-around
	}
	
	.weather{
		padding-top: 55px;
		.box{	
			img{
				height: 35px;
				width: 35px;
				padding-top: .1rem;
			}
			font{
				font-size: 12px;
			}		
		}
		
		.box2{
			img{
				height: 25px;
				width: 25px;
			}
			font{
				font-size: 12px;
				font-weight: bold;
				align-self: center;
			}
		}	
		.fontw{
			font-size: 12px;
			line-height: 20px;
		}
		.fontg{
			font-size: 14px;
			color: #19F2EB;
			line-height: 26px;
		}
	}
	
	.warn_work{
		display: flex;
		flex-direction: column;
		padding: .1rem;
		// margin-top: .2rem;
		// background:rgba(22,26,99,.8);
		color: #fff;
		.title{
			padding:.05rem;
			font-size: .16rem;
			text-align: left;
			border-bottom:.02rem solid #19F2EB;
			display: flex;
			flex-direction: row;
		}
		.car_work{
			display: flex;
			flex-direction: row;
			.box{
				overflow: hidden;
				position: relative;
				z-index: 10;
				width: 4rem;
				height: 2rem;
			}
			.boxnav {
			  text-align: center;
			  white-space: nowrap;
			  // height:calc(100% - .4rem); 
			  display: flex;
			  flex-direction: row;
			  justify-content: space-between;
			  align-items: center;
			  padding: .15rem 0;
			}			
			.boxitem {
			  text-align: left;
			  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本*/
			  white-space: nowrap; /* 不换行 */
			  overflow: hidden; 
			  // width:1.5rem;
			  font-size: .15rem;
			}
		}	
	}
	

	.workingview{
		display: flex;
		flex-direction: column;
		padding: .1rem;
		padding-bottom: .2rem;
		// background:rgba(22,26,99,.8);
		color: #fff;
		.title{
			padding:.05rem;
			font-size: .16rem;
			text-align: left;
			border-bottom:.02rem solid #19F2EB;
			display: flex;
			flex-direction: row;
		}
		.dividing_line{
			height: .01rem;
			width:  4rem;
			border-bottom:.015rem solid #19F2EB;
		}
		.car_work{
			display: flex;
			flex-direction: row;
			color:#F19F19;	
			.box{
				overflow: hidden;
				position: relative;
				z-index: 10;
				width: 4rem;
				height: 2rem;
			}
			.boxnav {
			  text-align: center;
			  white-space: nowrap;
			  height:calc(100% - .4rem); 
			  display: flex;
			  flex-direction: row;
			  justify-content: space-between;
			  align-items: center;
			  padding: .15rem 0;
			}			
			.boxitem {
			  text-align: left;
			  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本*/
			  white-space: nowrap; /* 不换行 */
			  overflow: hidden; 
			  // width:1.5rem;
			  font-size: .15rem;
			  // border-bottom: 1px #19F2EB solid;
			}
		}	
	}
	.warnbtn{
		width: .5rem;
		text-align: left;
		height: .3rem;
		padding: 0 0.1rem;
		align-self: center;
	}
	
	.dv-border-box-11{
		height: auto;
	}
	
	.dv-border-box-13{
		// margin-top: 5px;
	}
	
	.dv-border-box-11-title{
		font-size: 16px;
	}
	
	.dv-border-box-12{
		margin-top: 10px;
	}
	
	// .workview{
	// 	display: flex;
	// 	flex-direction: row;
	// 	justify-content:space-between;
	// 	padding-top: 0.2rem;
	// 	.img{
	// 		width:.6rem;
	// 		height:.6rem;
	// 		align-self: center;
	// 		padding-right: 0.1rem
	// 	}
		
		
	// }
	
	
	
	
	// .entity_echarts{
	// 	display: flex;
	// 	flex-direction: column;
	// 	justify-content: space-around;
	// 	width: 100%;
	// 	.item_chart{
	// 		text-align: center;
	// 		// height: 25%;
	// 		// border: 1px solid rgba(7,118,181,.5);
	// 		// box-shadow: inset 0 0 10px rgba(7,118,181,.4);
	// 		margin-bottom: 10px;
	// 		position: relative;
	// 	}	
		
	// 	.tit{
	// 		padding: 10px 10px 10px 30px;
	// 		border-bottom:1px solid rgba(7,118,181,.7);
	// 		font-size: 16px; 
	// 		font-weight: 500; 
	// 		position: relative;
	// 	}
	// 	.tit:before,{
	// 		position: absolute; 
	// 		content: ""; 
	// 		width: 12px; 
	// 		height: 12px; 
	// 		background: rgba(22,214,255,.9);
	// 		box-shadow: 0 0 5px rgba(22,214,255,.9); 
	// 		border-radius: 10px; 
	// 		left: 10px; top: 10px;
	// 		}	
	// 	.tit:after,.box:before{ 
	// 		width: 100%; 
	// 		height: 1px; 
	// 		content: ""; 
	// 		position: absolute; 
	// 		left: 0; 
	// 		bottom:-1px; 
	// 		background:linear-gradient(to right,#076ead,#4ba6e0,#076ead); 
	// 		box-shadow: 0 0 5px rgba(131,189,227,1); 
	// 		opacity: .6
	// 	}
	// 	.info{
	// 		padding: 5px;
	// 		height: 80%;
	// 		font-size: 12px;
	// 	}		
	// }
	
</style>
